import { Box, Typography } from "@mui/material";

import { useGetFeaturesQuery } from "api/memberPortal/features/features/features.api";

import ErrorMessage from "../../helpers/ErrorMessage";

import TestedFeaturesFormList from "./TestedFeaturesFormList";

import type { AppFormType } from "components/Forms/AppForm";

export interface FeatureData {
  id?: number; // undefined = new feature, number = existing feature
  feature?: number; // feature table ID (for existing features)
  feature_name: string;
}

interface TestedFeaturesSectionProps {
  form: AppFormType | { AppField: any; state: { values: any } };
  fieldName: string;
  title?: string;
  description?: string;
}

const TestedFeaturesSection = ({
  form,
  fieldName,
  title = "TESTED FEATURES",
  description = "Add features that have been tested for this product.",
}: TestedFeaturesSectionProps) => {
  const { data: allFeatures = [] } = useGetFeaturesQuery({});

  return (
    <Box className="mb-4">
      <Typography variant="body1" className="mb-2">
        {title}
      </Typography>
      <div className="border p-3 rounded">
        <Typography variant="body2" sx={{ color: "text.secondary", mb: 2 }}>
          {description}
        </Typography>

        <form.AppField name={fieldName}>
          {(field: any) => (
            <>
              <TestedFeaturesFormList
                form={form}
                fieldName={fieldName}
                handleChange={field.handleChange}
                allFeatures={allFeatures}
              />
              <ErrorMessage />
            </>
          )}
        </form.AppField>
      </div>
    </Box>
  );
};

export default TestedFeaturesSection;
